import { render, staticRenderFns } from "./custWriteOffTable.vue?vue&type=template&id=3f2cdbc4&scoped=true&"
import script from "./custWriteOffTable.vue?vue&type=script&lang=js&"
export * from "./custWriteOffTable.vue?vue&type=script&lang=js&"
import style0 from "./custWriteOffTable.vue?vue&type=style&index=0&id=3f2cdbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2cdbc4",
  null
  
)

export default component.exports